import Dictionary from '@/components/Dictionary/index';

const DictionaryPage = () => {
  return <Dictionary />;
};

export default DictionaryPage;
